/**
 * @description
 * links to the sample audio recording of Parle microphones at different distances
 * All this files are located in Cornerstone
 */
const audioFileLinks = {
  "Fair-1M-Phone.wav": "4636",
  "Fair-1M.wav": "4644",
  "Fair-2M-Phone.wav": "4635",
  "Fair-2M.wav": "4642",
  "Fair-3M-Phone.wav": "4634",
  "Fair-3M.wav": "4640",
  "Fair-4M-Phone.wav": "4632",
  "Fair-4M.wav": "4638",
  "Fair-5M-Phone.wav": "4628",
  "Fair-5M.wav": "4639",
  "Good-1M-Phone.wav": "4626",
  "Good-1M.wav": "4633",
  "Good-2M-Phone.wav": "4625",
  "Good-2M.wav": "4631",
  "Good-3M-Phone.wav": "4624",
  "Good-3M.wav": "4630",
  "Good-4M-Phone.wav": "4623",
  "Good-4M.wav": "4629",
  "Good-5M-Phone.wav": "4622",
  "Good-5M.wav": "4627",
  "Great-10M-Phone.wav": "4666",
  "Great-10M.wav": "4673",
  "Great-1M-Phone.wav": "4678",
  "Great-1M.wav": "4681",
  "Great-2M-Phone.wav": "4675",
  "Great-2M.wav": "4679",
  "Great-3M-Phone.wav": "4672",
  "Great-3M.wav": "4680",
  "Great-4M-Phone.wav": "4671",
  "Great-4M.wav": "4676",
  "Great-5M-Phone.wav": "4670",
  "Great-5M.wav": "4677",
  "Great-7.5M-Phone.wav": "4668",
  "Great-7.5M.wav": "4674",
  "Perfect-10M-Phone.wav": "4686",
  "Perfect-10M.wav": "4656",
  "Perfect-1M-Phone.wav": "4682",
  "Perfect-1M.wav": "4669",
  "Perfect-2M-Phone.wav": "4687",
  "Perfect-2M.wav": "4667",
  "Perfect-3M-Phone.wav": "4688",
  "Perfect-3M.wav": "4665",
  "Perfect-4M-Phone.wav": "4683",
  "Perfect-4M.wav": "4664",
  "Perfect-5M-Phone.wav": "4684",
  "Perfect-5M.wav": "4660",
  "Perfect-7.5M-Phone.wav": "4685",
  "Perfect-7.5M.wav": "4659",
  "Poor-1M-Phone.wav": "4649",
  "Poor-1M.wav": "4657",
  "Poor-2M-Phone.wav": "4647",
  "Poor-2M.wav": "4654",
  "Poor-3M-Phone.wav": "4645",
  "Poor-3M.wav": "4652",
  "Poor-4M-Phone.wav": "4643",
  "Poor-4M.wav": "4650",
  "Poor-5M-Phone.wav": "4641",
  "Poor-5M.wav": "4648",
  "Poor-7.5M-Phone.wav": "4637",
  "Poor-7.5M.wav": "4646"
};

export default audioFileLinks